
    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StopCauseMapping"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StopCauseMapping"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralIdTarget"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralIdEvent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopCauseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buffer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lookForward"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lookBack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regPriority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"split"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":169}}');
    doc.loc.source = JSON.parse('{"body":"fragment StopCauseMapping on StopCauseMapping {\\n  peripheralIdTarget\\n  peripheralIdEvent\\n  value\\n  stopCauseId\\n  buffer\\n  lookForward\\n  lookBack\\n  regPriority\\n  split\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
